"use client";

import Link from "next/link";
import { ThemeToggle } from "@/components/ThemeToggle";
import { useLanguage } from "@/lib/useLanguage";

type Variant = "light" | "dark";

type PublicHeaderControlsProps = {
  /** Show link to /account (product pages already have bottom nav on mobile). */
  showAccount?: boolean;
  variant?: Variant;
};

/** Header controls for public pages: theme + account only (language lives in footer). */
export function PublicHeaderControls({
  showAccount = true,
  variant = "light",
}: PublicHeaderControlsProps) {
  const { t } = useLanguage();
  const accountLabel = t.product?.account ?? "Account";

  const accountClass =
    variant === "dark"
      ? "text-sm px-3 py-1.5 rounded-lg text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800/60 transition-colors"
      : "text-sm px-3 py-1.5 rounded-lg bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors";

  return (
    <div className="flex items-center gap-2 shrink-0">
      <ThemeToggle />
      {showAccount ? (
        <Link href="/account" className={accountClass}>
          {accountLabel}
        </Link>
      ) : null}
    </div>
  );
}
